export class CompanyUser{
  id?: string;
  companyId?: string;
  name?: string;
  mail?: string;

  constructor(params?: Partial<CompanyUser>) {
    Object.assign(this, params);
  }
}